import React from 'react'
import PropTypes from 'prop-types'

// extends React.Component is required because of reference in parent
export default class FieldRating_MultiselectPopoverOption extends React.Component<any,any> {

    static propTypes = {
        scale           : PropTypes.number,

        option          : PropTypes.object,

        isHighlighted   : PropTypes.bool,
        isSelected      : PropTypes.bool,

        onClick         : PropTypes.func,
    }

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        const classes = Classes('option', 'pill', {
            'highlighted': this.props.isHighlighted
        })

        const stars = new Array(this.props.scale).fill(true).fill(false, this.props.option.value);

        return (
            <div className={classes} onClick={this.onClick}>
                {!this.props.option.isAllValuesOption &&
                    <React.Fragment>
                        <div className={Classes("ui5-cb fl-no-shrink s-16 m-r-10", this.props.className, {selected: this.props.isSelected})}/>
                        <div className="ui5-selector-rating">
                            {_.map(stars, (value, key)=>{
                                const classes = Classes("icon", {
                                    'filled i5-star'       : value,
                                    'empty i5-star-empty'  : !value,
                                })
                                return <div key={key} className={classes}/>
                            })}
                        </div>
                    </React.Fragment>}

                {!!this.props.option.isAllValuesOption &&
                    <div className="ui5-txt-default">{this.props.option.label}</div>}
            </div>
        )
    }
}